/* global Foundation */

import $ from 'jquery';
import moment from 'moment';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUiDefault from 'photoswipe/dist/photoswipe-ui-default';
import { destroyVideos } from '../../_video';

export default {
  name: 'EventInstanceModal',

  data() {
    return {
      title: null,
      url: null,

      event: null,
      loading: true,
    };
  },

  computed: {
    startDate() {
      return this.event ? moment(this.event.startDate) : null;
    },

    endDate() {
      return this.event ? moment(this.event.endDate) : null;
    },
  },

  methods: {
    show(title, url) {
      this.title = title;
      this.url = url;
      this.loadData();
      this.modal.open();
    },

    loadData() {
      if (this.dataXhr) {
        this.dataXhr.abort();
      }

      this.event = null;
      this.loading = true;

      this.dataXhr = $.ajax({
        type: 'GET',
        url: this.url,
        dataType: 'json',
        success: (event) => {
          this.event = event;
        },
      })
        .always(() => {
          this.loading = false;
        });
    },

    enlargePhoto() {
      const options = {
        index: 0,
        bgOpacity: 1,
        captionEl: false,
        fullscreenEl: false,
        shareEl: false,
        tapToClose: true,
        tapToToggleControls: false,
      };

      const photos = [
        {
          src: window.APP.context.site.files_url + this.event.photo.path,
          w: this.event.photo.width,
          h: this.event.photo.height,
        },
      ];

      const gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUiDefault, photos, options);
      gallery.init();
    },
  },

  created() {
    this.dataXhr = null;
    this.modal = null;
    this.pswpElement = document.querySelectorAll('.pswp')[0];
  },

  mounted() {
    this.$nextTick(() => {
      const $body = $(document.body);
      const $modal = $(this.$el);

      $modal
        .off('open.zf.reveal.app')
        .off('closed.zf.reveal.app')
        .on('open.zf.reveal.app', () => {
          $body.addClass('blurred');
        })
        .on('closed.zf.reveal.app', () => {
          destroyVideos($modal);
          $body.removeClass('blurred');
        });

      this.modal = new Foundation.Reveal($modal, { vOffset: 0 });
    });
  },

  template: `
    <div class="event-modal reveal large">
      <button class="close-button" data-close aria-label="Close modal" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
  
      <div class="event">
        <div class="event__title">{{ title }}</div>
        
        <div class="event__loading" v-if="loading">
          <ui-progress-circular :size="36" :indeterminate="true"/>
        </div>

        <div class="event__details" v-if="event">
          <div class="event__details__table-and-photo">
            <table class="transparent">
              <tbody>
                <tr v-if="event.county">
                  <th scope="row">County:</th>
                  <td>{{ event.county }}</td>
                </tr>
                <tr>
                  <th scope="row">Date:</th>
                  <td>
                    {{ startDate | moment('MMMM Do') }}
                    <span v-if="event.startDate !== event.endDate">
                      – {{ endDate | moment('MMMM Do') }}
                    </span>
                  </td>
                </tr>
                <tr v-if="event.timeStart || event.timeEnd">
                  <th scope="row">Time:</th>
                  <td>
                    {{ event.timeStart }}
                    <span v-if="event.timeEnd">
                      <span v-if="event.timeStart">—</span>
                      {{ event.timeEnd }}
                    </span>
                  </td>
                </tr>
                <tr v-if="event.location">
                  <th scope="row">Location:</th>
                  <td>{{ event.location }}</td>
                </tr>  
                <tr v-if="event.url">
                  <th scope="row">Website:</th>
                  <td><a :href="event.url" target="_blank">{{ event.url }}</a></td>
                </tr>
                <tr v-if="event.address">
                  <th scope="row">Address:</th>
                  <td><nl2br tag="span" :text="event.address" /></td>
                </tr>
                <tr v-if="event.contactName || event.contactPhone || event.contactEmail">
                  <th scope="row">Contact:</th>
                  <td>
                    <div v-if="event.contactName">{{ event.contactName }}</div>
                    <div v-if="event.contactPhone">{{ event.contactPhone }}</div>
                    <div v-if="event.contactEmail">{{ event.contactEmail }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <div v-if="event.photo" class="photo">
              <img :src="event.photo.url" alt="" @click="enlargePhoto">
            </div>
          </div>
        
          <div v-if="event.richDescription" class="description" v-html="event.richDescription"></div>
          <div v-else-if="event.textDescription" class="description">
            <nl2br tag="p" :text="event.textDescription" />
          </div>
        </div>
      </div>
    </div>
  `,
};
